import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { latestVersion: String }
  static targets = ["button", "notification"]

  connect() {
    this.checkForNewVersion()
    this.setupModalListener()
  }

  checkForNewVersion() {
    const lastSeenVersion = localStorage.getItem('lastSeenReleaseVersion')
    const currentVersion = this.latestVersionValue

    if (!lastSeenVersion || lastSeenVersion !== currentVersion) {
      this.showNotification()
    } else {
      this.hideNotification()
    }
  }

  showNotification() {
    if (this.hasNotificationTarget) {
      this.notificationTarget.classList.remove('d-none')
    }
  }

  hideNotification() {
    if (this.hasNotificationTarget) {
      this.notificationTarget.classList.add('d-none')
    }
  }

  markAsSeen() {
    localStorage.setItem('lastSeenReleaseVersion', this.latestVersionValue)
    this.hideNotification()
  }

  setupModalListener() {
    const modal = document.getElementById('versionModal')
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        console.log('Modal opened, highlighting new versions...')
        this.showLoadingState()
        
        // Use setTimeout to ensure smooth loading animation
        setTimeout(() => {
          this.highlightNewVersions()
          this.showContent()
          // Mark as seen when modal is opened, not when button is clicked
          this.markAsSeen()
        }, 300)
      })
      
      // Reset loading state when modal is hidden
      modal.addEventListener('hidden.bs.modal', () => {
        this.resetLoadingState()
      })
    } else {
      console.log('Modal not found')
    }
  }

  highlightNewVersions() {
    const lastSeenVersion = localStorage.getItem('lastSeenReleaseVersion')
    const container = document.getElementById('release-notes-container')
    
    console.log('Last seen version:', lastSeenVersion)
    console.log('Container found:', !!container)
    
    if (container) {
      container.setAttribute('data-last-seen-version', lastSeenVersion || '')
      
      const releaseItems = container.querySelectorAll('.release-item')
      console.log('Release items found:', releaseItems.length)
      
      releaseItems.forEach(item => {
        const version = item.getAttribute('data-version')
        const isNew = this.isNewVersion(version, lastSeenVersion)
        
        console.log(`Version ${version} is new: ${isNew}`)
        
        if (isNew) {
          item.classList.add('new-version')
        } else {
          item.classList.remove('new-version')
        }
      })
    }
  }

  isNewVersion(version, lastSeenVersion) {
    if (!lastSeenVersion) return true
    
    // Simple version comparison - assumes versions are in chronological order in the DOM
    const container = document.getElementById('release-notes-container')
    const allVersions = Array.from(container.querySelectorAll('.release-item')).map(item => 
      item.getAttribute('data-version')
    )
    
    const currentIndex = allVersions.indexOf(version)
    const lastSeenIndex = allVersions.indexOf(lastSeenVersion)
    
    return currentIndex < lastSeenIndex || lastSeenIndex === -1
  }

  showLoadingState() {
    const loading = document.getElementById('release-notes-loading')
    const container = document.getElementById('release-notes-container')
    
    if (loading) loading.style.display = 'block'
    if (container) container.style.display = 'none'
  }

  showContent() {
    const loading = document.getElementById('release-notes-loading')
    const container = document.getElementById('release-notes-container')
    
    if (loading) loading.style.display = 'none'
    if (container) container.style.display = 'block'
  }

  resetLoadingState() {
    const loading = document.getElementById('release-notes-loading')
    const container = document.getElementById('release-notes-container')
    
    if (loading) loading.style.display = 'block'
    if (container) container.style.display = 'none'
  }

  // Called when the version button is clicked
  buttonClicked() {
    // Don't mark as seen here - we'll do it when modal opens
    // This allows us to show which versions are new first
  }
}